import moment from 'moment-timezone';
import React, { useContext } from 'react';

import Button from '../../Buttons/Button/Button';
import { ReactComponent as ArrowDownLine } from '../../../assets/icons/ArrowDownLine.svg';
import { ReactComponent as Calendar } from '../../../assets/icons/Calendar.svg';
import Context from '../../../store/context';
import utils from '../../../services/utils';
import { useNavigate } from 'react-router-dom';
import InvoicePayedProcessDetails from '../../Details/InvoicePayedProcessDetails/InvoicePayedProcessDetails';

import classes from './HistoricalPayedCard.module.scss';

const HistoricalPayedCard = ({ invoice, onDownload, isSupplier = false }) => {
  const {
    modal: { showModal }
  } = useContext(Context);

  const navigate = useNavigate();
  const { isChecked, supplierName, issueDate, payableAmountAfterRetentions, paymentDate, supplierId } = invoice;

  // Obtener descripcion de cuenta de cobro (misma logica que en detalles)
  const chargeDescription =
    invoice?.description ||
    invoice?.descriptionItems ||
    invoice?.items?.[0]?.description ||
    invoice?.items?.[0]?.nameProduct ||
    'Sin descripción';
  const containerClasses = isSupplier ? ['card-suppliers', 'card-not-modal', classes.card] : ['card-not-check', 'card-not-modal', classes.card];
  
  // Estilos inline específicos para suppliers
  const suppliersStyle = isSupplier ? {
    width: '500px',
    minWidth: '500px',
    maxWidth: '500px',
    minHeight: '280px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    boxSizing: 'border-box',
    flexShrink: 0
  } : {};
  if (isChecked) {
    containerClasses.push('selected');
  }
  const showDetails = () => {
    showModal(<InvoicePayedProcessDetails invoice={invoice} supplier={supplierName} isProcess={false} />);
  };

  const goSupplier = () => {
    const url = `/itemsupplier/${supplierId}`;
    navigate(url);
  };
  return (
    <div className={containerClasses.join(' ')} style={suppliersStyle}>
      <div className={classes.title}>
        {/* {!isSupplier && <span className={`${classes.business} semibold-18`}>{supplierName}</span>} */}
        {!isSupplier && (
          <div className={classes.business}>
            <Button
              title={supplierName}
              className={`text-ellipsis ${classes.name} semibold-18`}
              custom='tertiary'
              onClick={goSupplier}>
              {supplierName}
            </Button>
          </div>
        )}

        <span title={chargeDescription} className={`${classes.description} text-ellipsis medium-16`}>
          {chargeDescription}
        </span>
        <div className={classes.calendar}>
          <Calendar />
          <span className={`${classes.color} medium-16`}>Se emitió el {moment(issueDate).format('DD/MM/YYYY')}</span>
        </div>
        <div className={classes['value-date']}>
          <span className='semibold-18'>{utils.moneyFormat(payableAmountAfterRetentions)}</span>
          <span className={`${classes.pay} medium-16`}>Pagado el {moment(paymentDate).format('DD/MM/YYYY')}</span>
        </div>
      </div>
      <div className={classes.buttons}>
        <Button className='semibold-16' Icon={ArrowDownLine} custom='quaternary' onClick={onDownload}>
          Descargar comprobante
        </Button>
        <Button onClick={showDetails} className='semibold-14' custom='quaternary'>
          Ver detalles
        </Button>
      </div>
      <Button onClick={showDetails} custom='quaternary' className={classes.button}>
        Ver detalles
      </Button>
    </div>
  );
};

export default HistoricalPayedCard;
